import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { async } from '@angular/core/testing';
import { FileUploader, FileSelectDirective } from 'ng2-file-upload';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-licence-management',
  templateUrl: './licence-management.component.html',
  styleUrls: ['./licence-management.component.scss'],
  standalone:true,
  imports:[CommonModule,MatButtonModule]
})

export class LicenceManagementComponent implements OnInit {
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public userLicenceUrl = BaseUrlConstantsService.USERS_LICENCE_LIST;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL + 'uploads/';
  public deleteLicenceUrl = BaseUrlConstantsService.DELETE_LICENCE;
  public inventoryInfoCount = BaseUrlConstantsService.INVENTORY_INFO_COUNT;
  public allDeviceTypeUrl = BaseUrlConstantsService.DEVICE_TYPE;
  public fileUploadUrl = BaseUrlConstantsService.FILE_UPLOAD;
  public licenceURL = BaseUrlConstantsService.LICENCE_URL;
  public getLicenseURL = BaseUrlConstantsService.LICENCE_URL;
  public _timeOut: any;
  public today: Date;
  public uploader: FileUploader;
  public licenceData: any =[];
  public pid: boolean;
  public _imgUrl: any;
  public fileName: any = '';
  public percentDone: any;
  public showViewButton: boolean;
  public showCancelBtn: boolean;
  public availableLicenseList: any = []
  public licenceDataTempArray: any = [];
  public imagePath: any;
  public showList: boolean;
  public emptyMsg: boolean;
  public infoForTab: any = {};
  public deviceType: string;
  public editLicenceID: any;
  public breadcrumbsArray: any = [{
    page_ref: 'licence-management',
    page_title: 'Licence management'
  }];

  constructor(
    private changeService: ChangeUsersService,
    public router: Router,
    public dialog: MatDialog,
    private service: BackendApiService,
    private activeRoute: ActivatedRoute) {
    this.utcTime();
    this.uploader = new FileUploader({ url: BaseUrlConstantsService.FILE_UPLOAD, itemAlias: 'photo' });
  }

  searchData(ev) {
    const term = ev.toLowerCase();
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }


  ngOnInit() {
    this.uploader.onBuildItemForm = (item, form) => {
      form.append('token', localStorage.getItem('token'));
      form.append('id', this.editLicenceID);
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      this.getlicence();
    };
    this.getAvailableLicense();
  }

  upload(files: any, id) {
    if (files[0].type === 'application/pdf') {
      if (files[0].name !== undefined && files[0].name === '') {
        this.fileName = '';
      } else {
        this.editLicenceID = id;
        this.showCancelBtn = true;
        this.fileName = files[0].name;
        this.uploader.uploadAll();
        this.uploader.onProgressItem = (progress: any) => {
          this.percentDone = progress['progress'];
        };
      }
    } else {
      this.service.showError('Invalid file format!');
    }
  }

  selectDeviceType1(sValue) {
    let e = <HTMLSelectElement>document.getElementById(sValue);
    let selectedValue = e.options[e.selectedIndex].value;
    this.deviceType = selectedValue;
    this.service.getData(this.licenceURL + `?device_type=${JSON.stringify(selectedValue)}`).then(async (res) => {
      this.infoForTab = {}
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.infoForTab = JSON.parse(JSON.stringify(res)).data.body;
        const ev = selectedValue;
        const term = ev.toLowerCase();
        this.licenceData = this.licenceDataTempArray.filter(result => result.device_type.toLowerCase().indexOf(term) >= 0);
      }
    });
  }


  getInfoInventory() {
    this.service.getData(this.licenceURL + `?device_type=${JSON.stringify(this.deviceType)}`).then((res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.infoForTab = {}
        this.infoForTab = JSON.parse(JSON.stringify(res)).data.body;
        clearTimeout(this._timeOut);
      }
    });
  }


  getAvailableLicense() {
    this.availableLicenseList = [];
    this.service.getDataWithQuery(this.getLicenseURL).then(res => {
      const result = JSON.parse(JSON.stringify(res))
      if (result.data.status === 'success') {
        if (result.data.body.length !== 0) {
          this.availableLicenseList = result.data.body;
          this.deviceType = this.availableLicenseList[0].device_type;
          this.getlicence();
          this.getInfoInventory();
        }
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }


  viewPDFInfo(pdffile) {
    if (pdffile === '') {
      this.service.showSuccess("No contract attached to this licence.");
    } else {
      window.open(this.imageBaseV2Url + pdffile, '_blank');
    }
  }


  async getlicence() {
    this.service.getData(this.userLicenceUrl + "/" + localStorage.getItem('user_id')).then(async (res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.licenceDataTempArray = []
        this.licenceData = [];
        if (JSON.parse(JSON.stringify(res)).data.body.length === 0) {
          this.showList = false;
          this.emptyMsg = true;
        } else {
          this.showList = true;
          this.emptyMsg = false;
          var newArr = JSON.parse(JSON.stringify(res)).data.body.map(function (val, index) {
            const monthNames = [
              'January', 'February', 'March', 'April', 'May', 'June', 'July',
              'August', 'September', 'October', 'November', 'December'
            ];
            let po_date = "";
            if (val.po_date !== null) {
              var dt_po = new Date(val.po_date);
              const day2 = dt_po.getDate();
              const monthIndex2 = dt_po.getMonth();
              const year2 = dt_po.getFullYear();
              po_date = `${day2} ${monthNames[monthIndex2]} ${year2}`;
            }
            var dt = new Date(val.created_at);
            const day = dt.getDate();
            const monthIndex = dt.getMonth();
            const year = dt.getFullYear();
            let created_at = `${day} ${monthNames[monthIndex]} ${year}`;
            return {
              key: index,
              active_devices: val.active_devices,
              client_id: val.client_id,
              company_name: val.company_name,
              contract_copy: val.contract_copy === null ? "" : val.contract_copy,
              created_at: created_at,
              id: val.id,
              number_of_licence: val.number_of_licence,
              device_type: val.device_type,
              device_type_id: val.device_type_id,
              quantity: val.left_quantity,
              po: val.po,
              po_date: po_date,
              updated_at: val.updated_at,
              user_id: val.user_id
            };
          })
          const ev = 'LV motors';
          const term = ev.toLowerCase();
          this.licenceDataTempArray = newArr;
          this.licenceData = this.licenceDataTempArray;
          // this.licenceData = newArr.filter(result => result.device_type.toLowerCase().indexOf(term) >= 0);
        }
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  async editInfo(id) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        licenceTypeId: id,
        functionType: 'edit',
        lastPageRef: 'licence-management'
      }
    };
    await this.router.navigate(['add-licence'], navigationExtras);
  }

  async showInventory(typeId, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceName: name
      }
    };
    await this.router.navigate(['devices'], navigationExtras);
  }

  async addLicence() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        lastPageRef: 'licence-management'
      }
    };
    await this.router.navigate(['add-licence'], navigationExtras);
  }

  async showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '150px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteUser(id, index);
      }
    });
  }


  goToPageLink(name: string) {
    this.router.navigate([name]);
  }


  deleteUser(licenceId, index) {
    this.service.deleteInfo(this.deleteLicenceUrl + "/" + licenceId).then(async (res) => {
      if (JSON.parse(JSON.stringify(res)).message.includes("successfully deleted")) {
        this.service.showSuccess('Successfully deleted.');
        this.licenceData.splice(index, 1);
        if (this.licenceData.length === 0) {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.service.showSuccess('Something went wrong.');
      }
    });
  }

  addLicense() {
    this.viewLicenseDialogBox();
  }

  viewLicenseDialogBox() {
    this.service.getDataWithQuery(this.allDeviceTypeUrl).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {} else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        let deviceResult = JSON.parse(JSON.stringify(res)).data.body;
        const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
          width: '300px',
          maxWidth: '100%',
          data: {
            type: 'addLicenseDailogBox',
            deviceTypeData: deviceResult
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          let self = this;
          self._timeOut = setInterval(function () {
            clearInterval(self._timeOut);
            self.getInfoInventory();
            self.getAvailableLicense();
          }, 1000);
        });
      }
    });
  }

  editLicenseType(id) {
    this.editLicenseTypeDialogBox(id);
  }
  editLicenseTypeDialogBox(id) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      maxWidth: '100%',
      data: {
        type: 'editLicenseTypeDialogBox',
        selectedLicenceID: id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'poDialogClose') {
        this.getlicence();
      }

    });
  }
}
